import { render, staticRenderFns } from "./appsum.vue?vue&type=template&id=5fadebc3&scoped=true&"
import script from "./appsum.vue?vue&type=script&lang=js&"
export * from "./appsum.vue?vue&type=script&lang=js&"
import style1 from "./appsum.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fadebc3",
  null
  
)

export default component.exports